import React from 'react';
import { connect } from 'react-redux';
import SiteDirectModule from 'components/organisms/siteDirect/SiteDirectModule';
import { toggleChannelExpansion } from 'services/siteDirect/duck';

class ChannelVisibilityContainer extends React.Component {
    render() {
        const { children, initialExpand, hide, toggleExpand, ...rest } = this.props;

        if (!children) {
            return null;
        }

        return <SiteDirectModule
            initialExpand={initialExpand}
            hide={hide}
            toggleExpand={toggleExpand}
            {...rest}>
            {children}
        </SiteDirectModule>;
    }
}

ChannelVisibilityContainer.propTypes = SiteDirectModule.propTypes;

export default connect((state, props) => {
    const { hide, initialExpand } = state.siteDirect.channels[props.ioChannel].expand;
    return { hide, initialExpand };
}, (dispatch, props) => ({
    toggleExpand: () => dispatch(toggleChannelExpansion(props.ioChannel))
}))(ChannelVisibilityContainer);



// WEBPACK FOOTER //
// ./src/containers/dashboards/siteDirect/ChannelVisibilityContainer.js